$(function () {
    if ($('#carouselBanners').length) {
        const carouselBanners = new Carousel(document.querySelector("#carouselBanners"), {
            fill: true,
            infinite: true,
            center: false,
            Dots: true,
            Navigation: false,
            Autoplay: {
                timeout: 5000
            }
        });
    }

    if ($('#carouselNews').length) {
        const carouselNews = new Carousel(document.querySelector("#carouselNews"), {
            fill: true,
            infinite: false,
            center: false,
            Dots: false,
            Navigation: true,
            Autoplay: false,
        });

        setTouch(carouselNews);
    }

    if ($('#carouselDiscount').length) {
        const carouselDiscount = new Carousel(document.querySelector("#carouselDiscount"), {
            fill: true,
            infinite: false,
            center: false,
            Dots: false,
            Navigation: true,
            Autoplay: false,
        });

        setTouch(carouselDiscount);
    }

    if ($('#carouselLast').length) {
        const carouselLast = new Carousel(document.querySelector("#carouselLast"), {
            fill: true,
            infinite: false,
            center: false,
            Dots: false,
            Navigation: true,
            Autoplay: false,
        });

        setTouch(carouselLast);
    }

    if ($('#carouselRecommended').length) {
        const carouselRecommended = new Carousel(document.querySelector("#carouselRecommended"), {
            fill: true,
            infinite: false,
            center: false,
            Dots: false,
            Navigation: true,
            Autoplay: false,
        });

        setTouch(carouselRecommended);
    }
});
